import axios from "axios";
import { apiEndpoint, apiEndpointFunction } from '@iso/lib/helpers/endpoint';
import { authHeader } from '@iso/lib/helpers/authHeader';

export const globalFormService = {
  storeOrUpdate,
  getForms,
  viewForm,
  getLivedForms,
  list,
  importForms,
  destroy,
  setLive
};

function getForms(){
    return (
        axios
            .get(
                apiEndpoint.globalForms,
                {
                    headers: authHeader(),
                }
            ).then(res => {
            if(res && res.status === 200){
                return res.data;
            }
        })
    );
}

function storeOrUpdate(data, id = null){
    return (id ? (
        axios
          .put(
              `${apiEndpointFunction.globalForms(id)}`,
            data,
            {
              headers: authHeader(),
            }
          )
    ) : (
        axios
          .post(
            apiEndpoint.globalForms,
            data,
            {
              headers: authHeader()
            }
          )
    )).then(res => {
        if(res && res.status === 200){
          return res.data;
        }
        return {};
    });
}

function viewForm(id){
    return (
        axios
            .get(
                `${apiEndpointFunction.globalForms(id)}`,
                {
                    headers: authHeader(),
                }
            ).then(res => {
            if(res && res.status === 200){
                return res.data;
            }
        })
    );
}

function getLivedForms(){
    return (
        axios
            .get(
                `${apiEndpoint.globalForms}/get-lived-forms`,
                {
                    headers: authHeader(),
                }
            ).then(res => {
            if(res && res.status === 200){
                return res.data;
            }
        })
    );
}

// Paginated + filtered library list (LIB-03, TAX-04).
// params: page, limit, type, category_global_form_id, sub_category_global_form_id, search
function list(params = {}){
    const query = Object.keys(params)
        .filter(key => params[key] !== undefined && params[key] !== null && params[key] !== '')
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
        .join('&');

    return (
        axios
            .get(
                `${apiEndpoint.globalForms}/list${query ? `?${query}` : ''}`,
                {
                    headers: authHeader(),
                }
            ).then(res => {
            if(res && res.status === 200){
                return res.data;
            }
            return {};
        })
    );
}

// Bulk JSON import (IMP-01). payload is a forms array (backend also accepts { forms: [...] }).
function importForms(payload){
    return (
        axios
            .post(
                `${apiEndpoint.globalForms}/import`,
                payload,
                {
                    headers: authHeader(),
                }
            ).then(res => {
            if(res && res.status === 200){
                return res.data;
            }
            return {};
        })
    );
}

function destroy(id){
    return (
        axios
            .delete(
                `${apiEndpointFunction.globalForms(id)}`,
                {
                    headers: authHeader(),
                }
            ).then(res => {
            if(res && res.status === 200){
                return res.data;
            }
            return {};
        })
    );
}

// Publish / unpublish (SSM-03; library publish = is_live).
function setLive(id, isLive){
    return (
        axios
            .put(
                `${apiEndpointFunction.globalForms(id)}/set-live`,
                { is_live: isLive ? 1 : 0 },
                {
                    headers: authHeader(),
                }
            ).then(res => {
            if(res && res.status === 200){
                return res.data;
            }
            return {};
        })
    );
}
